<template>
  <div class="body-form">
    <Loading v-if="isLoading" />
    <Popup :message="message" v-if="isPopup" @close="() => (isPopup = false)" />
    <div style="width: 90%; margin: 30px 0;">
      <div class="menus-top">
        <span class="blue-text" @click="$router.go(-1)">Career</span>
        <Arrow :width="20" :height="20" direct="left" strokeColor="#7B7E8C" class="icon" />
        <span style="color: #7b7e8c">{{ name }}</span>
      </div>
      <div class="card-form-head">
        <h1>Form {{ name }}</h1>
      </div>

      <div class="tab-selector" v-if="isEdit || isWatch">
        <button :class="['tab', activeTab === 'id' ? 'active-tab' : '']" @click="activeTab = 'id'">
          Bahasa Indonesia
        </button>
        <button :class="['tab', activeTab === 'en' ? 'active-tab' : '']" @click="activeTab = 'en'">
          Bahasa Inggris
        </button>
      </div>

      <div v-if="activeTab === 'id'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Indonesia</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Posisi</p>
              <v-text-field :disabled="isWatch" outlined v-model="form.position"
                :rules="[!!form.position || 'Wajib diisi!']" class="form-input" placeholder="Posisi" dense
                clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Slug Name</p>
              <v-text-field :disabled="isWatch" outlined v-model="form.slug_name"
                :rules="[!!form.slug_name || 'Wajib diisi!']" class="form-input" placeholder="Slug Name" dense
                clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Perusahaan</p>
              <v-text-field :disabled="isWatch" outlined v-model="form.company"
                :rules="[!!form.company || 'Wajib diisi!']" class="form-input" placeholder="Perusahaan" dense
                clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Lokasi</p>
              <v-text-field :disabled="isWatch" outlined v-model="form.location"
                :rules="[!!form.location || 'Wajib diisi!']" class="form-input" placeholder="Lokasi" dense
                clearable></v-text-field>
            </div>
            <!-- <div class="content-form">
              <p>Logo</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.logo"
                :rules="[!!form.logo || 'Wajib diisi!']"
                class="form-input"
                placeholder="Logo"
                dense
                clearable
              ></v-text-field>
            </div> -->
            <div class="content-form">
              <p>Tipe Kontrak</p>
              <v-select :disabled="isWatch" class="form-input" :items="contract_type" v-model="form.contract_type" solo
                :item-text="'name'" :item-value="'value'" placeholder="Pilih Tipe Kontrak"></v-select>
            </div>
            <div class="content-form">
              <p>Tipe Pekerjaan</p>
              <v-select :disabled="isWatch" class="form-input" :items="work_type" v-model="form.work_type" solo
                :item-text="'name'" :item-value="'value'" placeholder="Pilih Tipe Pekerjaan"></v-select>
            </div>
            <div class="content-form">
              <p>Level</p>
              <v-select :disabled="isWatch" class="form-input" :items="level" v-model="form.level" solo
                :item-text="'name'" :item-value="'value'" placeholder="Pilih Level"></v-select>
            </div>
            <div class="content-form">
              <p>Tanggal Berlangsung</p>
              <v-row no-gutters class="pt-2">
                <v-col cols="6">
                  <v-row no-gutters>
                    <v-col cols="5" class="pt-2"> Mulai </v-col>
                    <v-col cols="6">
                      <v-text-field :disabled="isWatch" outlined type="date"
                        :rules="[!!form.started_at || 'Wajib diisi!']" v-model="form.started_at" class="form-input"
                        placeholder="00:00" dense></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row no-gutters>
                    <v-col cols="6" class="pt-2"> Selesai </v-col>
                    <v-col cols="6">
                      <v-text-field :disabled="isWatch" outlined type="date"
                        :rules="[!!form.closed_at || 'Wajib diisi!']" v-model="form.closed_at" class="form-input"
                        placeholder="00:00" dense></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div class="content-form">
              <p class="section-title">Responsibilities</p>
              <div class="input-container">
                <div v-for="(data, idx) in form.career_detail.responsibilities" :key="idx" class="input-row">
                  <span class="input-number">{{ idx + 1 }}.</span>
                  <v-text-field :disabled="isWatch" outlined v-model="form.career_detail.responsibilities[idx]"
                    class="form-input" placeholder="Enter responsibility" dense hide-details></v-text-field>
                  <Button name="×" width="40px" height="40px" title="Remove Responsibility" outline class="delete-btn"
                    @click="() => form.career_detail.responsibilities.splice(idx, 1)" />
                </div>
                <Button name="Add Responsibility" icon="+" width="180px" height="40px" v-if="!isWatch"
                  @click="() => form.career_detail.responsibilities.push('')" class="add-btn" />
              </div>
            </div>
            <div class="content-form">
              <p class="section-title">Requirements</p>
              <div class="input-container">
                <div v-for="(data, idx) in form.career_detail.requirements" :key="idx" class="input-row">
                  <span class="input-number">{{ idx + 1 }}.</span>
                  <v-text-field :disabled="isWatch" outlined v-model="form.career_detail.requirements[idx]"
                    class="form-input" placeholder="Enter requirement" dense hide-details></v-text-field>
                  <Button name="×" width="40px" height="40px" title="Remove Requirement" outline class="delete-btn"
                    @click="() => form.career_detail.requirements.splice(idx, 1)" />
                </div>
                <Button name="Add Requirement" icon="+" width="180px" height="40px" v-if="!isWatch"
                  @click="() => form.career_detail.requirements.push('')" class="add-btn" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'en'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Inggris</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Position</p>
              <v-text-field :disabled="isWatch" outlined v-model="formEng.position" class="form-input"
                placeholder="Enter Position" dense clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Company</p>
              <v-text-field :disabled="isWatch" outlined v-model="formEng.company" class="form-input"
                placeholder="Enter Company" dense clearable></v-text-field>
            </div>
            <div class="content-form">
              <p class="section-title">Responsibilities</p>
              <div class="input-container">
                <div v-for="(data, idx) in formEng.career_detail.responsibilities" :key="idx" class="input-row">
                  <span class="input-number">{{ idx + 1 }}.</span>
                  <v-text-field :disabled="isWatch" outlined v-model="formEng.career_detail.responsibilities[idx]"
                    class="form-input" placeholder="Enter responsibility" dense hide-details></v-text-field>
                  <Button name="×" width="40px" height="40px" title="Remove Responsibility" outline class="delete-btn"
                    @click="() => formEng.career_detail.responsibilities.splice(idx, 1)" />
                </div>
                <Button name="Add Responsibility" icon="+" width="180px" height="40px" v-if="!isWatch"
                  @click="() => formEng.career_detail.responsibilities.push('')" class="add-btn" />
              </div>
            </div>
            <div class="content-form">
              <p class="section-title">Requirements</p>
              <div class="input-container">
                <div v-for="(data, idx) in formEng.career_detail.requirements" :key="idx" class="input-row">
                  <span class="input-number">{{ idx + 1 }}.</span>
                  <v-text-field :disabled="isWatch" outlined v-model="formEng.career_detail.requirements[idx]"
                    class="form-input" placeholder="Enter requirement" dense hide-details></v-text-field>
                  <Button name="×" width="40px" height="40px" title="Remove Requirement" outline class="delete-btn"
                    @click="() => formEng.career_detail.requirements.splice(idx, 1)" />
                </div>
                <Button name="Add Requirement" icon="+" width="180px" height="40px" v-if="!isWatch"
                  @click="() => formEng.career_detail.requirements.push('')" class="add-btn" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="submit-box" v-if="!isWatch">
        <Button name="Batalkan" outline class="me-3" @click="$router.push('/career')" />
        <Button :name="isEdit ? 'Simpan' : 'Simpan & Publish'" :width="isEdit ? '156px' : '200px'" @click="onSubmit"
          :disabled="!validData" style="background-color: #2d46cf; color: #ffffff" />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/ilustration/Loading.vue";
import Button from "@/components/Button.vue";
import Popup from "@/components/others/Popup.vue";
import Arrow from "@/components/icons/Arrow.vue";

export default {
  name: "FormCareer",
  components: {
    Loading,
    Button,
    Popup,
    Arrow,
  },
  computed: {
    validData() {
      return (
        this.form.position &&
        this.form.company &&
        this.form.location &&
        this.form.contract_type &&
        this.form.work_type &&
        this.form.level &&
        this.form.started_at &&
        this.form.closed_at &&
        this.form.slug_name &&
        this.form.career_detail.responsibilities[0] &&
        this.form.career_detail.requirements[0]
      );
    },
  },
  data() {
    return {
      id: null,
      name: "",
      isLoading: false,
      isWatch: false,
      isEdit: false,
      message: "",
      isPopup: false,
      activeTab: "id",
      contract_type: [
        { name: "Full-time", value: "Full-Time" },
        { name: "Part-time", value: "Part-Time" },
        { name: "Internship", value: "Internship" },
      ],
      work_type: [
        { name: "Onsite", value: "Onsite" },
        { name: "Remote", value: "Remote" },
      ],
      level: [
        { name: "Junior", value: "Junior" },
        { name: "Middle", value: "Middle" },
        { name: "Senior", value: "Senior" },
      ],
      form: {
        position: "",
        company: "",
        location: "",
        contract_type: "Full-Time",
        work_type: "Onsite",
        level: "Junior",
        logo: "",
        slug_name: "",
        started_at: "",
        closed_at: "",
        career_detail: {
          responsibilities: [""],
          requirements: [""],
        },
      },
      formEng: {
        position: "",
        company: "",
        logo: "",
        career_detail: {
          responsibilities: [""],
          requirements: [""],
        },
      },
    };
  },
  methods: {
    checkingType() {
      this.name = this.$route.meta.name;
      this.isWatch = this.$route.path.lastIndexOf("watch") >= 0;
      this.isEdit = this.$route.path.lastIndexOf("edit") >= 0;
      this.id = this.$route.params.id;
      if (!this.id) return;
      this.getDataCareer();
    },
    tidyUpDataFromGet(data) {
      const startedAt = new Date(data.career_detail.career.started_at);
      const closedAt = new Date(data.career_detail.career.closed_at);
      const formattedStartedAt = startedAt.toISOString().split("T")[0];
      const formattedClosedAt = closedAt.toISOString().split("T")[0];
      return {
        id: data.career_detail.career.id,
        position: data.career_detail.career.position,
        slug_name: data.career_detail.career.slug_name,
        company: data.career_detail.career.company,
        location: data.career_detail.career.location,
        contract_type: data.career_detail.career.contract_type,
        work_type: data.career_detail.career.work_type,
        level: data.career_detail.career.level,
        started_at: formattedStartedAt,
        closed_at: formattedClosedAt,
        logo: data.career_detail.career.logo,
        career_detail: {
          responsibilities: JSON.parse(data.career_detail.responsibilities[0]),
          requirements: JSON.parse(data.career_detail.requirements[0]),
        },
      };
    },
    async getDataCareer() {
      this.isLoading = true;
      try {
        const resp = await this.$crm_http.get("/v1/career-detail/" + this.id);
        this.form = this.tidyUpDataFromGet(resp.data.data);
        await this.getBilingual();
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    async getBilingual() {
      try {
        const { data } = await this.$crm_http.get(
          `/v1/bilingual/record/${this.id}?table_name=career&language_code=en`
        );
        const resp = JSON.parse(data.data.bilingual?.translated_data || "{}");
        this.formEng = {
          position: resp.position || "",
          company: resp.company || "",
          logo: resp.logo || "",
          career_detail: {
            responsibilities: resp.career_detail?.responsibilities || [""],
            requirements: resp.career_detail?.requirements || [""],
          },
        };
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmit() {
      this.isLoading = true;
      try {
        const payload = {
          position: this.form.position,
          slug_name: this.form.slug_name,
          company: this.form.company,
          location: this.form.location,
          contract_type: this.form.contract_type,
          work_type: this.form.work_type,
          level: this.form.level,
          started_at: this.form.started_at,
          closed_at: this.form.closed_at,
          logo: this.form.logo,
          career_detail: {
            responsibilities: this.form.career_detail.responsibilities,
            requirements: this.form.career_detail.requirements,
          },
        };

        if (this.isEdit) {
          await this.$crm_http.put("/v1/career/" + this.form.id, payload);
          await this.onSubmitBilingual();
        } else {
          await this.$crm_http.post("/v1/career", payload);
        }

        setTimeout(() => {
          this.$router.push("/career");
        }, 2000);
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to submit data.";
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async onSubmitBilingual() {
      const payload = {
        table_name: "career",
        record_id: this.id,
        language_code: "en",
        translated_data: JSON.stringify({
          position: this.formEng.position,
          company: this.formEng.company,
          logo: this.form.logo,
          location: this.form.location,
          contract_type: this.form.contract_type,
          work_type: this.form.work_type,
          level: this.form.level,
          started_at: this.form.started_at,
          closed_at: this.form.closed_at,
          slug_name: this.form.slug_name,
          career_detail: {
            responsibilities: this.formEng.career_detail.responsibilities,
            requirements: this.formEng.career_detail.requirements,
          },
        }),
      };
      try {
        await this.$crm_http.post("/v1/bilingual", payload);
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.checkingType();
  },
};
</script>

<style scoped>
.menus-top {
  padding-top: 10px;
  display: flex;
  font-size: 16px;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}

.card-form-head {
  display: flex;
  margin: 40px 0;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}

.card-form-head-2 {
  display: flex;
  margin-left: -35px;
  margin-right: -20px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid gray;
}

.card-form-head-2 h1 {
  font-weight: 700;
  font-size: 18px;
  color: #36373f;
  font-family: 'Poppins', sans-serif;
  margin: 0;
}

.tab-selector {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 50px;
}

.tab {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f9f9f9;
}

.active-tab {
  background-color: #2d46cf;
  color: white;
  border-color: #2d46cf;
}

.body-form {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafaf9;
  padding-bottom: 30px;
  min-height: 100vh;
}

.cart-form {
  position: relative;
  margin: 40px 0;
  border-radius: 30px;
  padding: 30px 40px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}

.language-section {
  margin-bottom: 30px;
}

.content-form {
  margin-top: 15px;
}

.content-form p {
  font-size: 14px;
  margin: 3px 0;
  font-weight: bold;
}

.section-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #36373f;
}

.input-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 10px 0;
}

.input-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.input-number {
  width: 30px;
  font-size: 14px;
  color: #7b7e8c;
  font-weight: 500;
}

.form-input {
  border-radius: 10px !important;
  background-color: transparent !important;
  flex: 1;
}

.form-input:focus {
  border-color: #2d46cf;
  box-shadow: 0 0 5px rgba(45, 70, 207, 0.3);
}

.add-btn {
  background-color: #2d46cf;
  color: #ffffff;
  border-radius: 8px;
  font-size: 14px;
  margin: auto;
  font-weight: 500;
}

.add-btn:hover {
  background-color: #1e3bb5;
}

.delete-btn {
  border-color: #d3d6e1;
  color: #b80f0a;
  font-size: 16px;
  font-weight: bold;
}

.delete-btn:hover {
  background-color: #ffe6e6;
  border-color: #b80f0a;
}

.no-space {
  margin-bottom: -20px;
}

.submit-box {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.blue-text {
  font-weight: bold;
  color: #162ca2;
  cursor: pointer;
}

@media screen and (max-width: 600px) {
  .input-row {
    flex-wrap: wrap;
  }

  .form-input {
    max-width: 100%;
  }

  .add-btn {
    width: 100%;
  }
}
</style>